import { ChevronRightLg } from '@prenuvo/halo-icon';
import { Button, Typography } from '@prenuvo/halo-web';
import { addBasePath } from 'next/dist/client/add-base-path';
import { useRouter } from 'next/navigation';
import { BrowserView, isAndroid, isIOS } from 'react-device-detect';
import QRCode from './QRCode';

export const DownloadAppBanner = () => {
  const router = useRouter();

  const handleDownload = () => {
    if (isAndroid) {
      router.push('https://play.google.com/store/apps/details?id=com.prenuvo');
    } else if (isIOS) {
      router.push('https://apps.apple.com/id/app/prenuvo/id1442317064');
    } else {
      // EC-197: For other devices, redirect to the app store
      router.push('https://apps.apple.com/id/app/prenuvo/id1442317064');
    }
  };

  const backgroundImageUrl = addBasePath('/images/dl_app_banner_bg.png');

  return (
    <div
      className={
        'm-4 mt-4 flex min-h-24 max-w-[800px] flex-col items-start justify-between gap-6 rounded-xl bg-white bg-cover bg-[right_25%_top_0] bg-no-repeat px-6 py-4 sm:flex-row sm:items-center md:mx-auto'
      }
      style={{ backgroundImage: `url(${backgroundImageUrl})` }}
    >
      {/* EC-197: Show QR code only on desktop */}
      <BrowserView>
        <div className="w-22">
          <QRCode />
        </div>
      </BrowserView>
      <div className="flex-1">
        {/*TODO: For unkonwn reason, Typography component as variant="h5" as="h5" gets hidden on mobile
         * so we have added the className to make it visible on mobile as temporary fix
         */}
        <Typography
          variant="h5"
          as="h5"
          className="block font-sofia text-lg font-extrabold leading-[1.238rem]"
        >
          Prepare for your appointment
          <br /> with convenience
        </Typography>
        <Typography className="mt-2" variant="paragraph-sm-bold" as="p">
          Download our app for better experience.
        </Typography>
      </div>
      <div className="w-full sm:w-48">
        {/* TODO: Currnt button component doesn't support transparent background
         * so as a temp fix we have set the background of the first span to hsl(206, 36%, 91%) (same as the background color of the banner)
         */}
        <Button
          rightIcon={ChevronRightLg}
          variant="gradient"
          className={{
            root: 'w-full sm:w-48 [&>span]:justify-center [&>span]:bg-[hsl(206,36%,91%)] sm:[&>span]:justify-around',
          }}
          onClick={handleDownload}
        >
          Download Now
        </Button>
      </div>
    </div>
  );
};
